document.addEventListener('DOMContentLoaded', () => {
  function getCookie(cookiename: string) {
    var cookiestring = RegExp(cookiename + "=[^;]+").exec(document.cookie);
    return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
  }

  function setCouponCode(element: Element, couponCode: string) {
    const code = element.getElementsByClassName('code')[0];
    code.innerHTML = couponCode;
    element.classList.remove('hidden');
  }

  const discount_cookie = getCookie('discount_code');
  if (discount_cookie && discount_cookie?.toLowerCase() != 'remove_discount_codes') {

    const code_msgs = document.getElementsByClassName('hero-coupon-msg');
    Array.from(code_msgs).forEach((el) => { setCouponCode(el, discount_cookie) });

  }

});



window.sprTruncateFix = class {
  /**
   * Class that waits for Shopify product review code to initialize
   * and then add truncation events and logic
   *
   * It uses setInterval as a to wait for SPR object to load.
   * Checks how many reviews are there.
   * Then waits for the reviews to load. to add classes and eventlistners.
   *
   * @param {SPRCheckThreshold} number  times interval will be triggered before cancelling
   * @param {intervalTime}  number miliseconds to wait before checking again
   * @returns Self
   *
   */
  public isSPRLoaded: boolean = false;
  private SPRCheckCounter: number = 0;
  private SPRintervalId: number;
  private reviewsIntervalId: number = NaN;
  private reviwesCheckCounter: number = 0;
  public totalReviews: number = NaN;

  constructor(
    private SPRCheckThreshold: number = 20,
    private intervalTime: number = 1000,
    private checkForSPR: boolean = false
  ) {
    if (this.checkForSPR) {
      this.SPRintervalId = window.setInterval(
        this.doSPRCheck,
        this.intervalTime
      );
    } else {      
      this.reviewsIntervalId = window.setInterval(
        this.checkForReviews,
        this.intervalTime
      );
    }
  }

  doSPRCheck = (): void => {
    /**
     * Function that waits for SPR to be initialized.
     * Checks for SPR.batchSize to check for non zero reviews
     * then triggers checkForReviwes
     *
     * @returns void
     */
    if (window.hasOwnProperty("SPR")) {
      this.isSPRLoaded = true;
      window.clearInterval(this.SPRintervalId);
      if (window.SPR.batchSize > 0) {
        this.reviewsIntervalId = window.setInterval(
          this.checkForReviews,
          this.intervalTime
        );
      }
    } else {
      if (this.SPRCheckCounter > this.SPRCheckThreshold) {
        window.clearInterval(this.SPRintervalId);
      }
      this.SPRCheckCounter += 1;
    }
  };

  checkForReviews = (): void => {
    /**
     * Function that waits for SPR DOM elements to be initialized.
     * then triggers truncateReviewBody for each element.
     *
     * @returns void
     */
    const reviewBodies = Array.from(
      document.getElementsByClassName("spr-review-content")
    );
    if (reviewBodies.length > 0) {
      window.clearInterval(this.reviewsIntervalId);
      reviewBodies.forEach(this.truncateReviewBody);
      this.initializeHorizontalScroll();
    } else {
      if (this.reviwesCheckCounter > this.SPRCheckThreshold) {
        window.clearInterval(this.reviewsIntervalId);
      }
      this.reviwesCheckCounter += 1;
    }
  };

  truncateReviewBody = (reviewBody: Element): void => {
    /**
     * Checks if review is longer than line-clamp css property.
     * then triggers truncateReviewBody() for each element.
     * If so adds an event listener
     *
     * @param reviewBody - HTML Element of review body
     * @returns void
     */

    console.log("reviewBody: ", reviewBody);
    console.log("isLineClamped? ", this.isLineClamped(reviewBody))

    if (this.isLineClamped(reviewBody)) {
      reviewBody.classList.add("clamped");
      reviewBody.addEventListener("click", this.toggleTruncation);
    } else {
      reviewBody.classList.remove('clamped');
      reviewBody.removeEventListener("click", this.toggleTruncation);
    }
  };

  toggleTruncation = (event: Event): void => {
    /**
     * Toggles trucation
     *
     * @param event - Event
     * @returns void
     */
    if (event.target instanceof Element) {
      const content = event.target.closest(".spr-review-content");
      content?.classList.toggle("untrucated");
    }
  };

  isLineClamped = (reviewBody: Element): boolean => {
    /**
     * Checks if ScrollHeight is height than client height.
     * Returns boolean
     *
     * @param reviewBody - Element
     * @returns boolean
     */
    const element = reviewBody.getElementsByClassName(
      "spr-review-content-body"
    )[0] as HTMLElement;

    return element.scrollHeight > element.clientHeight;
  };

  initializeHorizontalScroll = () => {
    const sprContent =
      document.getElementsByClassName("spr-review-container")?.length > 0
        ? document.getElementsByClassName("spr-review-container")
        : document.getElementsByClassName("spr-content");

    if (sprContent) {
      const reviewScroller = new window.HorizontalScroller({
        scrollContainer: sprContent[0] as HTMLElement,
        wrapperClass: "spr-reviews",
        slideClass: "spr-review",
      });
    }
  };
};

document.addEventListener('DOMContentLoaded', () => {
  window.SPRTFIX = new window.sprTruncateFix();
});

interface Window {
  SPR: any;
  sprTruncateFix: any;
  SPRTFIX: any;
}